import {Grid} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './Body.classes'

type Props = React.PropsWithChildren<{
  lead?: React.ReactElement
  tail: React.ReactElement
}>

export const Body = memo<Props>(function Body({lead, tail, children}) {
  return (
    <Grid wrap="nowrap" container>
      {lead && (
        <Grid className={classes.lead} item>
          {lead}
        </Grid>
      )}
      {children && (
        <Grid item xs>
          {children}
        </Grid>
      )}
      <Grid className={classes.tail} item>
        {tail}
      </Grid>
    </Grid>
  )
})
